import { render, staticRenderFns } from "./FormSelections.vue?vue&type=template&id=27baaf0e"
import script from "./FormSelections.vue?vue&type=script&lang=js"
export * from "./FormSelections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports